module.exports = __webpack_public_path__ + "static/img/bg-fr.15159e42.webp";